function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useTopicPage_DeleteLabeMutation } from "sprout-graphql";
import { useCallback, useMemo } from "react";
import { useNavigationListItem } from "@sprout/list-navigation";
import { Card, CardContent, CardLink } from "@sprout/client-components/dist/Card";
import { DeleteOutlined, LocalOfferTwoTone } from "sprout-ui-icons";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
import { Flex, Text, Box } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import { Button } from "sprout-ui-dom/dist/Button";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useTopicPage } from "../TopicPageContext";
const StyledLocalOfferTwoTone = styled(LocalOfferTwoTone)`
  width: 36px;
  height: 36px;

  path:nth-child(2) {
    fill: ${({ $color  })=>$color};
    stroke: ${themeGet("colors.white.100")};
    stroke-width: 1;
  }
`;
const TopicPageViewsLabelsLabel = (props)=>{
    const { label , index , to  } = props;
    const { style , text , id  } = label;
    const { navProps , helpers: navigationItemHelpers  } = useNavigationListItem(label.nodeId, useMemo(()=>({
            index,
            object: label
        }), [
        index,
        label
    ]));
    const { isOwnerOrAdmin , disabled  } = useTopicPage();
    const isLabelEnabled = isOwnerOrAdmin && !disabled;
    const showSnackbar = useSnackbar();
    const [deleteLabel] = useTopicPage_DeleteLabeMutation();
    const handleDelete = useCallback(()=>{
        deleteLabel({
            variables: {
                labelId: id
            }
        }).then(()=>{
            showSnackbar({
                message: "Label deleted"
            });
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        deleteLabel,
        id,
        showSnackbar
    ]);
    return /*#__PURE__*/ _jsxs(Card, _objectSpread({}, navProps, {
        isActive: navigationItemHelpers.isActive,
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: to
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(StyledLocalOfferTwoTone, {
                        $color: colorMap[style]
                    }),
                    text && /*#__PURE__*/ _jsx(Box, {
                        as: Text,
                        fontWeight: "medium",
                        fontSize: 3,
                        ml: 3,
                        flex: "1",
                        minWidth: "0",
                        children: text
                    }),
                    isLabelEnabled && /*#__PURE__*/ _jsx(Flex, {
                        ml: "auto",
                        pl: 0,
                        onClick: handleDelete,
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "circle",
                            width: "36px",
                            height: "36px",
                            children: /*#__PURE__*/ _jsx(DeleteOutlined, {})
                        })
                    })
                ]
            })
        ]
    }));
};
export default TopicPageViewsLabelsLabel;
